/**
 * Operating system name mappings
 *
 * Maps user-agent OS strings to normalized short codes
 */
export const OS_MAP: Record<string, string> = {
  Windows: 'win',
  macOS: 'mac',
  'Mac OS': 'mac',
  Linux: 'linux',
  Ubuntu: 'linux',
};
